<template>
  <div class="main-tree-container">
    <el-dialog
      width="75%"
      v-if="modalOpen"
      :visible.sync="modalOpen"
      center
      :title="currentTreeNode.text[3]"
      custom-class="more-info-dialog"
    >
      <div class="more-info__inner">
        <div
          v-for="(el, index) in getModalData"
          :key="index"
          class="mono-text"
          :style="{
            whiteSpace: setWhiteSpacePre ? 'pre' : 'normal',
            marginLeft: setWhiteSpacePre ? '-9px' : '0px',
          }"
        >
          {{ el }}
        </div>
      </div>
      <div class="bottom-buttons">
        <div>
          <el-checkbox v-model="setWhiteSpacePre">{{
            $t("navigation.commonTree.showScroll")
          }}</el-checkbox>
        </div>
        <el-button @click="saveInfoClick">{{
          $t("navigation.commonTree.saveInFile")
        }}</el-button>
      </div>
    </el-dialog>
    <div style="display: flex">
      <el-tooltip
        effect="light"
        :content="$t('navigation.commonTree.details')"
        placement="bottom-start"
      >
        <span>
          <el-button
            v-if="getLogType === 'admin_task_log'"
            :disabled="infoDisable"
            class="el-icon-info info-button"
            @click="infoClick"
            type="info"
            size="mini"
          ></el-button>
        </span>
      </el-tooltip>
      <div
        class="current-node"
        v-if="currentTreeNode && getLogType === 'admin_task_log'"
      >
        <span
          v-for="(t, index) in currentTreeNode.text"
          class="current-node-text-element"
          :key="index"
          >{{ t }}</span
        >
      </div>
    </div>
    <el-card class="box-card">
      <ul class="tree-list">
        <div v-for="(element, index) in getTreeDataLog" :key="index">
          <tree-node :node="element" @info-event="infoEvent"></tree-node>
        </div>
      </ul>
    </el-card>
  </div>
</template>

<script>
import TreeNode from "./TreeNode";
import { mapGetters } from "vuex";
export default {
  components: {
    TreeNode,
  },
  data() {
    return {
      modalOpen: false,
      setWhiteSpacePre: true,
    };
  },
  methods: {
    infoEvent() {
      if (!this.infoDisable && this.getLogType === "admin_task_log")
        this.infoClick();
    },
    infoClick() {
      if (!this.currentTreeNode.off_end) {
        this.$message.error(this.$t("navigation.commonTree.taskNotCompleted"));
        return;
      }
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getModalInfo", {
          pid: this.currentTreeNode.pid.toString(),
          off_start: this.currentTreeNode.off_start.toString(),
          off_end: this.currentTreeNode.off_end.toString(),
        })
        .then(() => {
          this.modalOpen = true;
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    saveInfoClick() {
      let file = this.getModalData.join("\n");
      let fileName = this.currentTreeNode.text.join(" ");
      file = fileName + "\n\n" + file;
      let href = "data:application/octet-stream," + encodeURIComponent(file);
      var link = document.createElement("a");
      link.setAttribute("href", href);
      link.setAttribute(
        "download",
        this.currentTreeNode.text[0] + this.currentTreeNode.text[3] + ".txt"
      );
      document.body.appendChild(link); // Required for FF

      link.click(); // This will download the data file named "my_data.csv"
    },
  },
  computed: {
    ...mapGetters([
      "getTreeDataLog",
      "getLogType",
      "currentTreeNode",
      "getModalData",
    ]),
    infoDisable() {
      if (this.currentTreeNode) {
        if (this.currentTreeNode.typeNode === "D") return true;
        else return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.box-card {
  margin-top: 20px;
  margin-left: 5px;
  max-height: 80vh;
  overflow: auto;
  scrollbar-color: grey lightgrey;
  scrollbar-width: auto;
  white-space: nowrap;
}
.box-card::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.box-card::-webkit-scrollbar-track {
  background-color: lightgrey;
}

.box-card::-webkit-scrollbar-thumb {
  background-color: grey;
}
.tree-list {
  margin-top: 10px;
}
.el-tooltip {
  margin-left: 25px;
}
.info-button {
  margin-top: 5px;
}
.main-tree-container {
  background-color: var(--main-background);
}
.current-node {
  margin-top: 9px;
  font-weight: 600;
  margin-left: 15px;
}
.current-node-text-element {
  margin-right: 5px;
}
</style>
